import { render, staticRenderFns } from "./PageDescubre.vue?vue&type=template&id=89742da4&"
import script from "./PageDescubre.vue?vue&type=script&lang=js&"
export * from "./PageDescubre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports